<aside class="dashboard-sidebar">
  <div class="dashboard-sidebar__brand">
    <span class="material-icons navbar-logo-img">track_changes</span>
    <span class="navbar-title title">{{ 'DASHBOARD_MENU.TITLE' | translate | uppercase }}</span>
  </div>

  <div class="d-flex flex-column align-items-center mt-3 mb-2">
    <button class="image-container" *ngIf="!loading" (click)="edit(user())">
      <img
        *ngIf="user().picture !== ''; else defaultProfilePicture"
        (error)="user().picture = ''"
        class="profile-picture rounded-circle shadow-lg border border-3 border-white"
        [src]="user().picture"
        id="img"
        alt="{{ user().username }}"
      />
      <ng-template #defaultProfilePicture>
        <em class="fa fa-user-circle fa-5x text-secondary"></em>
      </ng-template>
      <div class="overlay profile-picture rounded-circle d-flex justify-content-center align-items-center">
        <em class="fa-solid fa-pen fa-bounce text-white fa-lg"></em>
      </div>
    </button>
    <span class="fw-bold fs-4 text-dark mt-2">{{ user().firstname }}</span>
    <span class="text-muted fs-6 fst-italic">{{ user().name }}</span>
  </div>

  <hr class="mx-3 text-muted" />
  <nav aria-label="Dashboard navigation" class="dashboard-sidebar__nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <span class="nav-link" style="cursor: default">
          <em class="fa fa-tachometer-alt pe-2"></em>
          {{ 'DASHBOARD_MENU.DASHBOARD' | translate }}
        </span>
        <ul class="navbar-nav ps-3">
          <li class="nav-item">
            <a class="nav-link" routerLink="/dashboard">
              <em class="fa fa-robot pe-2"></em>
              {{ 'DASHBOARD_MENU.SAGEMAKER' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/dashboard/add-user" routerLinkActive="active">
              <em class="fa fa-user-plus pe-2"></em>
              {{ 'DASHBOARD_MENU.ADD_USER' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/dashboard/restore" routerLinkActive="active">
              <em class="fa fa-undo-alt pe-2"></em>
              {{ 'DASHBOARD_MENU.RESTORE' | translate }}
            </a>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" id="referencer-menu-item" *ngIf="isReferencer" routerLink="/referencer/home">
              <em class="fa fa-map pe-2"></em>
              {{ 'MENU.REFERENCER' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="contributor-menu-item" *ngIf="isContributor" routerLink="/contributor/home">
              <em class="fa fa-users pe-2"></em>
              {{ 'MENU.CONTRIBUTOR' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="contributor-menu-item" *ngIf="isAdmin" routerLink="/admin">
              <em class="fa fa-tools pe-2"></em>
              {{ 'MENU.ADMINISTRATION' | translate }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</aside>
<footer class="dashboard-footer">
  <button ngbDropdownItem type="button" class="btn btn-link" (click)="disconnect()">
    <i class="bi bi-box-arrow-in-right"></i>
    {{ 'MENU.LOGOUT' | translate }}
  </button>
</footer>
